<template lang='pug'>
  div
    bionic-metrics-running-indicator-circular(v-if='isRunning')
    v-icon(:size='size' v-if='!isRunning' :color='color') {{icon}}
</template>

<script>
import BionicMetricsRunningIndicatorCircular from '@/components/RunningIndicatorCircular';

export default {
  name: 'BionicMetricsTestRowStatus',
  components: {BionicMetricsRunningIndicatorCircular},
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    status: {
      type: String,
      default: 'NO_DATA'
    },
    isRunning: {
      type: [Boolean, Number],
      default: false
    },
    size: {
      type: Number,
      default: 24
    }
  },
  computed: {
    icon() {
      if (this.disabled) return 'not_interested';
      if (this.status === 'PASSING') return 'check_circle';
      if (this.status === 'FAILING') return 'cancel';
      if (this.status === 'CANCELLED' || this.status === 'INCOMPLETE') return 'remove_circle_outline';
      return 'remove';
    },
    color() {
      if (this.disabled) return 'default';
      if (this.status === 'PASSING') return 'success';
      if (this.status === 'FAILING') return 'error';
      return 'default';
    }
  },
  data() {
    return {};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
